export enum FEATURE_FLAGS_FOR_SELLER {
  BILLING = 'Billing',
  DOCUMENT_VISIBLE_ON_SELFCARE = 'DocumentSelfcare',
  PRODUCT_WITHOUT_CATALOG = 'ProductWithoutCatalog',
  HOLDER_VISIBILITY = 'HolderVisibility',
  QRCODE_UPLOAD = 'UploadByQrCode',
  MULTI_PRODUCT_CARRIER_LABELS = 'MultiProductCarrierLabels',
  COMMERCIAL_GESTURE_MANUAL_MODULE_INSTANCIATION = 'CommercialGestureManualModuleInstaciation',
  DISPLAY_REPAIRED_TAG = 'DisplayRepairedTag',
  OPTIONAL_EMAIL = 'OptionalEmail',
  OPTIONAL_PHONE_NUMBER = 'OptionalPhoneNumber',
  DESACTIVATE_ACTOR_COVERAGE_RULE = 'DeactivateActorCoverageRule',
  QUALIREPAR = 'Qualirepar',
  QUOTE_INPUTATION = 'QuoteInputation',
  VIDEO_CALL = 'VideoCall',
  USER_ASSIGNMENT = 'UserAssignment',
  TAG_FILE_STATUS = 'TagFileStatus',
  SEARCH_PRODUCT_SPAREPART = 'SearchProductSparePart',
  FILE_FILTER_PRESET = 'FileFilterPreset',
  EXTENDED_INTERVENTION_REPORT = 'ExtendedInterventionReport',
  DECLARE_SAFETY_RISK_STATUS = 'DeclareSafetyRiskStatus',
  DECLARE_BENEFICIARY = 'DeclareBeneficiary',
  EDIT_CLIENT_ADDRESS = 'EditClientAddress',
  DISPLAY_ACCOUNTING_TAB = 'DisplayAccountingTab',
  HISTORICAL_FILE_VISIBLE = 'HistoricalFileVisible',
  TRANSPORT_PLAN = 'TransportPlan',
  AI_MODEL_TYPE_MAPPING = 'AIModelTypeMapping',
  HOME_INTERVENTION = 'HomeIntervention',
  DEFAULT_NEW_UI = 'DefaultNewUi',
  SYNC_FROM_STANDARD = 'SyncFromStandard',
  NEW_CREATE_FILE = 'NewCreateFile',
  ENABLE_ADD_INFO_ON_INTERVENTION_REPORT = 'EnableAddInfoOnInterventionReport',
  FRAUD_SCORING = 'FraudScoring',
  SELFCARE_LOGOUT = 'SelfCareLogOutButton',
  MESSAGING_TAB = 'FileMessaging',
  CASE_WIDGETS = 'CaseWidgets',
  NEW_CREATE_FILE_OPTIONAL_PROOF_OF_PURCHASE = 'NewCreateFileOptionalProofOfPurchase',
  FORCE_ONE_PRODUCT_PER_CLAIM = 'ForceOneProductPerClaim',
  PACKING_PARCEL_MODULE = 'PackingParcelModule',
  QUOTE_MARGIN = 'QuoteMargin',
  CREATE_FILE_BY_ASSISTANT = 'CreateFileByAssistant',
  LLM_FILE_MESSAGING = 'LLMFileMessaging',
  POST_ONBOARDING_STEPS = 'PostOnboardingSteps',
}
